import { ItemClassificationType, ItemStatus } from './items.models';

export interface ExpediteRequest {
  expediteRequestEntityId: string;
  expediteRequestId: string;
  status: ExpediteRequestStatus | null;
  itemsTotal: number | null;
  requestedDueDate: string | Date | null;
  alternateDueDate: string | Date | null;
  requesterEntityId: string | null;
  requester: string | null;
  requestedDate: string | Date | null;
  completedDate: string | Date | null;
  comment: string | null;
}

export interface ExpediteRequestDetails {
  expediteRequestEntityId: string;
  expediteRequestId: string;
  status: ExpediteRequestStatus | null;
  requestedDueDate: string | Date | null;
  alternateDueDate: string | Date | null;
  requesterEntityId: string | null;
  requester: string | null;
  requesterEmailAddress: string | null;
  requestedDate: string | Date | null;
  completedDate: string | Date | null;
  comment: string | null;
}

export enum ExpediteRequestStatus {
  Initiating = 1,
  Submitted = 2,
  InProgress = 3,
  Approved = 4,
  Rejected = 5,
  Obsolete = 6,
}

export function getExpediteRequestStatusName(status: ExpediteRequestStatus | null): string {
  switch (status) {
    case ExpediteRequestStatus.Initiating:
      return 'expedite-request.status.initiating';
    case ExpediteRequestStatus.Submitted:
      return 'expedite-request.status.submitted';
    case ExpediteRequestStatus.InProgress:
      return 'expedite-request.status.in-progress';
    case ExpediteRequestStatus.Approved:
      return 'expedite-request.status.approved';
    case ExpediteRequestStatus.Rejected:
      return 'expedite-request.status.rejected';
    case ExpediteRequestStatus.Obsolete:
      return 'expedite-request.status.obsolete';
    default:
      return 'expedite-request.status.unknown';
  }
}
export interface ExpediteItem {
  expediteItemEntityId: string | null;
  expediteItemId: string | null;
  itemEntityId: string | null;
  itemId: string | null;
  productId: string | null;
  description: string | null;
  country: string | null;
  itemClassificationType: ItemClassificationType | null;
  expediteItemStatus: ExpediteItemStatus | null;
  status: ItemStatus | null;
  originalDueDate: string | Date | null;
}

export enum ExpediteItemStatus {
  Submitted = 1,
  InProgress = 2,
  Approved = 3,
  Rejected = 4,
}

export interface ExpediteRequestLink {
  id: string;
  routerLink: string[];
}
